import type { ColumnMeta, FieldDef } from '@/lib/types';
import type { GridColumn, LookupSpec } from '@/grid/types';
import { columnsFromMeta } from '@/grid/DataGrid';
import { api } from '@/lib/api';

const up = (s: string) => s.toLocaleUpperCase('tr-TR');

/**
 * Sonuç kolonları + Database_Yonetim alan tanımları → grid kolonları (Delphi Util2.Grid_Baslik).
 *  BASLIK → başlık · GIZLE → gizli · GIRIS_KILITLE → salt okunur · HIZALAMA · MASKE (DisplayFormat)
 *  TOPLAM → alt toplam · FONT/ZEMIN_RENK → renk · COMBO_SQL → combo · LISTE_SQL → seçim penceresi · GENIS_ACIKLAMA → memo
 */
export function dizaynColumns(meta: ColumnMeta[], fields: FieldDef[], opts: { tag: number; editableCols?: Set<string> }): GridColumn[] {
  const byField = new Map(fields.map((f) => [up(f.field), f]));
  return columnsFromMeta(meta).map((c) => {
    const f = byField.get(up(c.key));
    const col: GridColumn = { ...c, field: f };
    if (opts.editableCols && !opts.editableCols.has(up(c.key))) col.readonly = true;
    if (!f) return col;
    if (f.caption) col.caption = f.caption;
    if (f.hidden) col.hidden = true;
    if (f.readonly) col.readonly = true;
    if (f.noFocus) col.noFocus = true;
    if (f.align) col.align = f.align;
    if (f.mask) col.mask = f.mask;
    if (f.total) col.total = f.total;
    col.filterable = f.filter; // Delphi FILITRELEME: kolon filtrelenebilir mi
    if (f.memo) col.editor = 'memo';
    if (f.time) col.editor = 'time';
    if (f.colors) col.colors = { font: f.colors.font ?? undefined, back: f.colors.back ?? undefined, cond: f.colors.cond, condValue: f.colors.condValue };
    if (f.combo) {
      col.editor = 'combo';
      col.loadComboItems = async () => (await api<{ items: string[] }>(`/screens/${opts.tag}/dizayn/fields/${f.id}/combo`, { method: 'POST', body: {} })).items.map(String);
    }
    if (f.lookup) {
      col.editor = 'lookup';
      col.lookup = fieldLookup(opts.tag, f);
    }
    return col;
  });
}

export function fieldLookup(tag: number, f: FieldDef): LookupSpec {
  const l = f.lookup!;
  return {
    title: l.title || f.caption || f.field,
    fetch: (q, row) => api(`/screens/${tag}/dizayn/fields/${f.id}/lookup`, { body: { query: q, row } }),
    apply: (picked) => {
      const out: Record<string, any> = { [f.field]: picked[l.returnField] ?? picked[f.field] };
      l.import.forEach((target, i) => { const src = l.export[i]; if (src && src in picked) out[target] = picked[src]; });
      return out;
    },
    validate: (value, row) => api(`/screens/${tag}/dizayn/fields/${f.id}/validate`, { body: { value, row } }),
  };
}
